export enum AllowedTransactionRegistrations {
    defaultRegistration = 0,
    ambulance = 1,
    vc = 2,
}
